<div class="form-check form-switch">
  <input type="checkbox" class="form-check-input" [id]="name" (change)="valueChanged($event)"
    [(ngModel)]="selectedValue">
  <label class="form-check-label clickable withOpacity" [for]="name" [ngClass]="selectedValue ? 'text-success fw-bold' : ''">{{ 'SELECT_FOR_SHIPMENT' | translate}}</label>
</div>
